import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = ({ variant = "outline", size = "sm", showLabel = false }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className="flex items-center space-x-2"
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? (
        <>
          <Sun size={16} />
          {showLabel && <span>Light Mode</span>}
        </>
      ) : (
        <>
          <Moon size={16} />
          {showLabel && <span>Dark Mode</span>}
        </>
      )}
    </Button>
  );
};

export default ThemeToggle;